import { Email, AssignmentInd, PhoneIphone, VpnKey } from "@mui/icons-material";

export const pixOptions = [
  {
    key: "email",
    title: "E-mail",
    icon: Email,
  },
  {
    key: "document",
    title: "CPF/CNPJ",
    icon: AssignmentInd,
  },
  {
    key: "phone",
    title: "Celular",
    icon: PhoneIphone,
  },
  {
    key: "randomKey",
    title: "Chave aleatória",
    icon: VpnKey,
  },
];
